/**
 * 발주화면 소속(업체)별 전략 베이스 클래스
 *
 * 업체별로 다른 발주 흐름(필드 표시/검증/저장/이벤트)을 이 클래스의
 * 훅 메서드에 응집시킨다. Baljoo.js 의 if(isMercuryInsurance) 식 분기를
 * 대체.
 *
 * 구현체는 Base 를 상속해 필요한 훅만 override 하고 Registry 에 등록한다.
 *
 * 호출 흐름 (Baljoo 측):
 *   1. const strategy = getSosokStrategy(ORDER.order_sosok)
 *   2. strategy.onInitPage($pane)        — 화면 초기화 시 필드 노출 토글 등
 *   3. strategy.onInitHandler(self)      — 이벤트 핸들러 등록
 *   4. strategy.bindMeta(ORDER)          — print('meta') 시점의 값 바인딩
 *   5. strategy.validateMeta()           — 발주 전 검증 (false 반환 시 중단)
 *   6. strategy.applyMetaToOrder(ORDER)  — ORDER.meta 직렬화 + howtopay 조정
 */
export default class Base {
    /** 이 전략이 처리할 소속코드인가 */
    matches(/* sosok */) { return false; }

    /** 화면 초기화: 필드 노출/숨김, 디폴트 상태 */
    onInitPage(/* $pane */) {}

    /** 이벤트 핸들러 등록 (입력 변경, 토글 등) */
    onInitHandler(/* baljoo */) {}

    /** print('meta') 시점에 호출 — ORDER.meta 를 폼에 바인딩 */
    bindMeta(/* order */) {}

    /**
     * 발주 전송 전 검증
     * @returns {{ok: boolean, msg?: string, focus?: string}}
     */
    validateMeta() { return { ok: true }; }

    /**
     * ORDER 객체에 메타 데이터 직렬화 + 부수 효과(howtopay 조정 등) 적용
     * checkSubmit 마지막 단계에서 호출
     */
    applyMetaToOrder(/* order */) {}
}
